module.exports = __webpack_public_path__ + "img/button-list-menu.b4834271.svg";